export default "__VITE_PUBLIC_ASSET__02a0f966__"